export const BRAND = {
  name: "FEMORA LIFE",
  tagline: "Women Wellness Supplements",
  logo:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_092e4061-6f54-4c6c-b0f6-560b72acbb58/artifacts/h6tzahz4_Updated%20Logo.png",
  heroCollage:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_092e4061-6f54-4c6c-b0f6-560b72acbb58/artifacts/815hlish_ElevenLabs_image_gpt-image-2_Generate%20instag_2026-07-24T21_09_07.webp",
};

export const IMAGES = {
  lifestyle:
    "https://images.pexels.com/photos/8374584/pexels-photo-8374584.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000",
  science:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_ingredient-explorer-5/artifacts/tpq32i9c_image.png",
  collection:
    "https://images.pexels.com/photos/20140029/pexels-photo-20140029.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
  { label: "Shop", href: "/products" },
  { label: "Why Femora Life?", href: "/why-femora-life" },
  { label: "The Science", href: "/#science" },
  { label: "About", href: "/#about" },
];

export const TRUST_BADGES = [
  { icon: "FlaskConical", label: "Clinically-Studied Ingredients" },
  { icon: "ShieldCheck", label: "GMP Certified Manufacturing" },
  { icon: "Leaf", label: "Vegetarian & Non-GMO" },
  { icon: "Ban", label: "No Fillers or Proprietary Blends" },
];

export const CATEGORIES = [
  {
    key: "life-stage",
    title: "Life-Stage & Reproductive Health",
    desc: "Targeted formulas for PCOS, fertility, pregnancy, postpartum, menopause and healthy aging.",
    image:
      "https://images.pexels.com/photos/8374584/pexels-photo-8374584.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000",
  },
  {
    key: "everyday",
    title: "Everyday Wellness & Maintenance",
    desc: "Daily foundations for mood, beauty, energy, sleep, digestion and complete nutrition.",
    image:
      "https://images.pexels.com/photos/20140029/pexels-photo-20140029.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000",
  },
];

export const SCIENCE_POINTS = [
  {
    title: "Bioavailable, active forms",
    body: "We use the forms your body actually absorbs — Methylfolate, Methylcobalamin, chelated minerals and Ubiquinol — not the cheap, poorly-absorbed alternatives.",
  },
  {
    title: "Fully transparent labels",
    body: "Every active ingredient and its exact per-serving dose is disclosed. No hidden proprietary blends, ever.",
  },
  {
    title: "Formulated for women",
    body: "Each formula is designed around the clinical evidence for a specific stage or need in a woman's life.",
  },
];

export const TESTIMONIALS = [
  { name: "Ananya R.", location: "Mumbai", product: "PCOS", rating: 5, text: "The 40:1 inositol ratio actually made a difference to my cycle. Finally a PCOS formula that's transparent about doses." },
  { name: "Priya S.", location: "London", product: "Fertility", rating: 5, text: "Loved that it uses Ubiquinol and methylfolate, not the cheap forms. My doctor approved every ingredient." },
  { name: "Meera K.", location: "Bengaluru", product: "Iron+", rating: 5, text: "Gentle chelated iron — no stomach upset at all, and my energy is back. A game changer for me." },
  { name: "Sara T.", location: "Dubai", product: "Sleep", rating: 5, text: "Fall asleep faster and wake up clear-headed, not groggy. The calmest I've felt in months." },
  { name: "Nisha P.", location: "Singapore", product: "Radiance", rating: 5, text: "Skin looks genuinely more hydrated and my nails are stronger. The marine collagen dose is generous." },
];

export const PREMIUM_UPGRADES = [
  { from: "Folic Acid", to: "Methylfolate (L-5-MTHF)", why: "The bioactive form the body uses directly — vital for the ~40% of women with an MTHFR variant." },
  { from: "Cyanocobalamin B12", to: "Methylcobalamin", why: "Active coenzyme form; no liver conversion required, better retained in tissue." },
  { from: "Magnesium Oxide", to: "Magnesium Glycinate", why: "Oxide absorbs at ~4% and can be laxative; glycinate is gentle and highly bioavailable." },
  { from: "Ferrous Sulfate", to: "Ferrous Bisglycinate", why: "2–4x better absorbed with significantly less constipation and GI upset." },
  { from: "Zinc Oxide", to: "Zinc Bisglycinate", why: "Far higher absorption than oxide, and gentler on an empty stomach." },
  { from: "Ubiquinone CoQ10", to: "Ubiquinol", why: "The active reduced form — critical as absorption declines with age." },
];
